module.exports = __webpack_public_path__ + "img/button-app-store.cb4296cb.svg";